export default __webpack_public_path__ + "static/media/Guru-Parampara-21.ddd30158.png";